/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect } from "react";
import { Paper, Grid } from "@material-ui/core";

import { InputTextMaster, MasterButton } from "App/Component/ui";
import { STYLE_JENIS_LAYANAN } from "./helpers";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance2,
} from "App/constants";

import {
  convertToValidPrice,
  defaultToastError,
  defaultToastSuccess,
  formatRupiah,
} from "App/utils/helpers";
import { RESET_STATE_JENIS_LAYANAN } from ".";
import { LIST_URL_MASTER } from "utils/masters";

export default function FormJenisLayanan({ formData, setFormData, run }) {
  const classes = STYLE_JENIS_LAYANAN();
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const addJenisLayanan = async () => {
    return instance2.post(LIST_URL_MASTER.jenis_layanan.add, {
      ...formData,
    });
  };

  const updateJenisLayanan = () => {
    return instance2.post(
      LIST_URL_MASTER.jenis_layanan.update,
      {
        ...formData,
      },
      {
        headers: {
          idjenis_layanan: formData.id,
        },
      }
    );
  };

  useEffect(() => {
    setFormData({
      ...formData,
      harga: convertToValidPrice(formData.harga2),
    });
  }, [formData.harga2]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (formData.name === "") {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Nama tidak boleh kosong");
    } else {
      try {
        if (formData.id === "") {
          await addJenisLayanan();
          defaultToastSuccess("Berhasil Menambah Jenis Layanan");
        } else if (formData.id !== "") {
          await updateJenisLayanan();
          defaultToastSuccess("Berhasil Mengubah Jenis Layanan");
        }
        run(!run);
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        setFormData(RESET_STATE_JENIS_LAYANAN);
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(error?.response?.data?.message);
      }
    }
  };

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  return (
    <Paper className={classes.paper}>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={4}>
            <InputTextMaster
              name='id'
              label='ID'
              id='id'
              placeholder='-'
              readOnly={true}
              disabled={true}
              value={formData.id}
            />
          </Grid>
          <Grid item xs={6} sm={4}>
            <InputTextMaster
              name='name'
              label='INFO'
              id='name'
              value={formData.name}
              onChange={handleChange("name")}
              placeholder='Info Jenis Layanan'
            />
          </Grid>
          <Grid item xs={6} sm={4}>
            <InputTextMaster
              name='kode_bridge'
              label='KODE BRIDGE'
              id='kode_bridge'
              value={formData.kode_bridge}
              onChange={handleChange("kode_bridge")}
              placeholder='Kode Bridge'
            />
          </Grid>

          <Grid item xs={6} sm={4}>
            <InputTextMaster
              name='harga'
              label='HARGA'
              id='harga'
              placeholder='0'
              value={formData.harga2}
              onInput={(e) => {
                let val = e.target.value;
                setFormData({
                  ...formData,
                  harga2: formatRupiah(val),
                });
              }}
            />
          </Grid>
          <Grid item sm={4}>
            <InputTextMaster
              name='typeofcare_code'
              label='JENIS RAWAT'
              id='typeofcare_code'
              disabled={true}
              readOnly={true}
              value={formData.typeofcare_code}
              onChange={handleChange("typeofcare_code")}
              placeholder='Jenis Rawat'
            />
          </Grid>

          {/* <Grid item xs={6} sm={4}>
            <InputOptionMaster
              name='typeofcare_code'
              label='JENIS RAWAT'
              id='typeofcare_code'
              withSearch={false}
              needParse={false}
              value={formData.typeofcare_code}
              onChange={handleChange("typeofcare_code")}
              data={
                jenisRawat?.length > 0
                  ? jenisRawat
                  : [DEFAULT_VALUE_OPTION("Jenis Rawat")]
              }
            />
          </Grid> */}
        </Grid>
        <div className='mt-2'>
          <hr style={{ margin: "1rem 0", opacity: "0.3" }} />
          <Grid
            container
            direction='row'
            justifyContent='space-between'
            alignItems='center'>
            <MasterButton
              outline={true}
              type={"button"}
              color='danger'
              name='Reset'
              size='md'
              onClick={() => setFormData(RESET_STATE_JENIS_LAYANAN)}
            />
            <MasterButton
              outline={false}
              type={"submit"}
              color={disabled.color}
              name={disabled.label}
              size='md'
            />
          </Grid>
        </div>
      </form>
    </Paper>
  );
}
